import {getData,postData} from '@/assets/js/api.js'

//创建群组
export const Post = (params,fn) => {
	let methods = '/api/TemporaryGroup/Post';
	postData(methods, params, 1, fn);
};

//修改群组
export const UpdateName = (params,fn) => {
	let methods = '/api/TemporaryGroup/UpdateName';
	postData(methods, params, 1, fn);
};

//删除群组
export const Delete = (params,fn) => {
	let methods = '/api/TemporaryGroup/Delete';
	getData(methods, params, 1, fn);
};

//获取群组
export const Get = (params,fn) => {
	let methods = '/api/TemporaryGroup/Get';
	getData(methods, params, 1, fn);
};

//获取群组设备
export const GetList = (params,fn) => {
	let methods = '/api/TemporaryGroup/GetList';
	getData(methods, params, 1, fn);
};